import * as Yup from 'yup'
import i18n from 'i18n'

export const phoneValidator = () => {
  return Yup.string().matches(
    /^\d{2}\s\d{4,5}-\d{4}$/g,
    i18n.t('inputErrors:invalidMobile')
  )
}
